module.exports = __webpack_public_path__ + "img/204.dc298d20.jpg";